<template>
  <div class="min-vh">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">
        WhatsApp TEMPLATE
      </h1>
      <button class="create-button" @click="handleCreate()">
        <font-awesome-icon icon="plus-square" />
        <span class="ml-2"> CREATE</span>
      </button>
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <div class="d-flex flex-wrap align-items-center mb-2 filter-bar">
        <b-form-input
          v-model="search"
          size="sm"
          placeholder="ค้นหาชื่อ Template"
          class="filter-search"
        />
        <b-form-select
          v-model="statusFilter"
          size="sm"
          :options="statusOptions"
          class="filter-status"
        />
        <span class="small text-muted ml-auto"
          >{{ filteredItems.length }} / {{ items.length }} Template</span
        >
      </div>
      <b-table
        responsive
        striped
        hover
        class="table-list"
        :items="filteredItems"
        :fields="fields"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(name)="data">
          <div class="font-weight-bold">{{ data.item.name }}</div>
          <div class="small text-muted body-preview">
            {{ bodyText(data.item) }}
          </div>
        </template>
        <template v-slot:cell(category)="data">
          <b-badge
            :variant="data.item.category === 'MARKETING' ? 'warning' : 'info'"
            >{{ data.item.category }}</b-badge
          >
        </template>
        <template v-slot:cell(status)="data">
          <b-badge :variant="statusInfo(data.item.status).variant">{{
            statusInfo(data.item.status).label
          }}</b-badge>
          <div
            v-if="
              data.item.status === 'REJECTED' &&
              data.item.rejectedReason &&
              data.item.rejectedReason !== 'NONE'
            "
            class="small text-danger"
          >
            {{ data.item.rejectedReason }}
          </div>
          <div
            v-if="data.item.qualityScore && data.item.qualityScore.score"
            class="small text-muted"
          >
            คุณภาพ: {{ data.item.qualityScore.score }}
          </div>
        </template>
        <template v-slot:cell(id)="data">
          <div class="d-flex justify-content-center">
            <b-link class="text-link" @click="onEdit(data.item.id)">
              <font-awesome-icon
                icon="pencil-alt"
                class="text-warning"
                title="Edit"
              />
            </b-link>
            <b-link class="text-link ml-3" @click="onDeleteModal(data.item)">
              <font-awesome-icon
                icon="trash-alt"
                class="text-danger"
                title="Delete"
              />
            </b-link>
          </div>
        </template>
      </b-table>
      <!-- <b-row class="no-gutters px-3 px-sm-0">
          <b-col class="form-inline justify-content-center justify-content-sm-between">
            <div v-if="rows > 0" class="my-auto">
              Showing {{ startPage | numeral("0,0") }} to {{ endPage | numeral("0,0") }} of
              {{ rows | numeral("0,0") }} entires
            </div>
            <div v-else class="my-auto">{{ rows || 0 }} entire</div>
            <div class="d-sm-flex m-3">
              <b-pagination
                v-model="filter.pageNo"
                :total-rows="rows"
                :per-page="filter.perPage"
                class="m-md-0"
                @change="pagination"
                align="center"
              ></b-pagination>
            </div>
          </b-col>
        </b-row> -->
    </div>
    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMsgDelete"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
  </div>
</template>

<script>
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
export default {
  name: "WhatsAppMessageTemplate",
  components: {
    ModalAlertConfirm,
  },
  data: function () {
    return {
      modalMsgDelete: "",
      bodyDelete: {
        id: 0,
        name: "",
      },
      isBusy: false,
      startPage: 1,
      endPage: 10,
      rows: 0,
      filter: {
        pageNo: 1,
        perPage: 10,
      },
      fields: [
        {
          key: "name",
          label: "ชื่อเทมเพลต",
          class: "text-left",
        },
        {
          key: "category",
          label: "หมวดหมู่",
          class: "w-100px",
        },
        {
          key: "language",
          label: "ภาษา",
          class: "w-100px",
        },
        {
          key: "status",
          label: "สถานะ",
          class: "w-100px",
        },

        {
          key: "id",
          label: "",
          class: "w-action",
        },
      ],
      items: [],
      search: "",
      statusFilter: "",
      statusOptions: [
        { value: "", text: "ทุกสถานะ" },
        { value: "APPROVED", text: "อนุมัติแล้ว" },
        { value: "PENDING", text: "รอตรวจ" },
        { value: "REJECTED", text: "ไม่อนุมัติ" },
        { value: "PAUSED", text: "ถูกพักใช้" },
        { value: "DISABLED", text: "ถูกปิดใช้" },
      ],
      activeCopyId: false,
      disabledCopy: true,
    };
  },
  computed: {
    filteredItems() {
      const keyword = this.search.trim().toLowerCase();
      return this.items.filter(
        (x) =>
          (!keyword || (x.name || "").toLowerCase().includes(keyword)) &&
          (!this.statusFilter || x.status === this.statusFilter)
      );
    },
  },
  created: async function () {
    await this.pagination(1);
  },
  methods: {
    statusInfo(status) {
      const map = {
        APPROVED: { label: "อนุมัติแล้ว", variant: "success" },
        PENDING: { label: "รอตรวจ", variant: "warning" },
        IN_APPEAL: { label: "กำลังอุทธรณ์", variant: "warning" },
        REJECTED: { label: "ไม่อนุมัติ", variant: "danger" },
        PAUSED: { label: "ถูกพักใช้", variant: "secondary" },
        DISABLED: { label: "ถูกปิดใช้", variant: "dark" },
      };
      return map[status] || { label: status, variant: "secondary" };
    },
    bodyText(item) {
      const body = (item.components || []).find((c) => c.type === "BODY");
      return body ? body.text : "";
    },
    getList: async function () {
      this.isBusy = true;
      await this.axios
        .get(
          `${this.$baseUrl}/whatsapp/GetTemplateList/${this.$route.query.whatsappId}`
        )
        .then((data) => {
          if (data.result == 1) {
            this.items = (data.detail && data.detail.data) || [];
            this.rows = this.items.length;
          } else {
            this.items = [];
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        })
        .catch(() => {
          this.items = [];
        });
      this.isBusy = false;
    },
    handleCreate() {
      this.$router
        .push({
          path: `/whatsapp-template/create`,
          query: { whatsappId: this.$route.query.whatsappId },
        })
        .catch(() => {});
    },
    onEdit(id) {
      this.$router
        .push({
          path: `/whatsapp-template/${id}`,
          query: { whatsappId: this.$route.query.whatsappId },
        })
        .catch(() => {});
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getList();
      this.getShowingPage(Page);
    },
    async getShowingPage(page) {
      let result = await this.$getShowingPage(page, this.filter);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
    },
    onDeleteModal(data) {
      this.bodyDelete.id = data.id;
      this.bodyDelete.name = data.name;
      this.modalMsgDelete = `คุณต้องการลบ ${data.name} ใช่หรือไม่? (ลบทุกภาษาที่ใช้ชื่อนี้ และใช้ชื่อนี้สร้างใหม่ไม่ได้ 30 วัน)`;
      this.$refs.ModalAlertConfirm.show();
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      const deleteBody = {
        templateName: this.bodyDelete.name,
        templateId: this.bodyDelete.id,
      };
      await this.axios
        .post(
          `${this.$baseUrl}/whatsapp/DeleteTemplate/${this.$route.query.whatsappId}`,
          deleteBody
        )
        .then(async (data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            await this.pagination(1);
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-bar {
  gap: 8px;
}

.filter-search {
  max-width: 260px;
}

.filter-status {
  max-width: 180px;
}

.body-preview {
  max-width: 480px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
